import { FC, useEffect, useState } from "react";
import { observer } from "mobx-react";

export const ProgressBar: FC<{
  value: number;
  secondaryValue?: number;
}> = observer(({ value, secondaryValue = 0 }) => {
  const [animate, setAnimate] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(false);
    }, 4000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const width = value === 1 ? 100 : value < 1 ? value * 100 : value;
  const secondaryWidth =
    secondaryValue === 1 ? 100 : secondaryValue < 1 ? secondaryValue * 100 : secondaryValue;

  return (
    <div
      className={
        "relative border border-gray bg-default rounded-xl h-3 w-full" +
        (animate ? " animate-pulse" : "")
      }
    >
      <div
        className={"absolute bg-primary-light"}
        style={{ width: `${secondaryWidth}%`, height: "100%" }}
      ></div>
      <div
        className={"absolute bg-gray-x-hard rounded-xl"}
        style={{ width: `${width}%`, height: "100%" }}
      ></div>
    </div>
  );
});
